<template>
	<div>
		出售
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {}
		},
		methods: {},
		mounted() {}
	};
</script>
<style lang='scss' scoped>
</style>
